import {AdminAxios} from "../../common/Axios";

const isInit = false;
/* 매체별 통계 리스트 조회 */
export async function selectStaticsMedia(params) {
  //post
  let returnVal = null;
  if(isInit){
    return {rows: [
        {historyDate: 20250805, revenueAmount : 10, requestCount: 10, responseCount: 10, exposureCount: 10, validClickCount: 10, costAmount: 10}
      ], totalCount: 1}
  }
  await AdminAxios('POST', `/media/statistics/media`, params)
    .then((response) => {
      const { data, statusCode } = response;
      if(statusCode === 200){
        returnVal = data;
      }else{
        returnVal = {totalElements: 0 ,content:[]}
      }
    }).catch((e) => returnVal = false)
  return returnVal;
}

/* 선택매체지면별통계리스트조회 */
export async function selectStaticsInventoryByMedia(accountId, params) {
  //post
  let returnVal = null;
  if(isInit){
    return {rows: [
        {historyDate: 20250805, revenueAmount : 10, requestCount: 10, responseCount: 10, exposureCount: 10, validClickCount: 10, costAmount: 10}
      ], totalCount: 1}
  }
  await AdminAxios('POST', `/media/statistics/${accountId}/media/inventory`, params)
    .then((response) => {
      const { data, statusCode } = response;
      if(statusCode === 200){
        returnVal = data;
      }else{
        returnVal = {totalElements: 0 ,content:[]}
      }
    }).catch((e) => returnVal = false)
  return returnVal;
}
export async function updateAllowCampaignWeight(params) {
  //post
  let returnVal = null;
  await AdminAxios('PUT', `/adver/campaign/weight`, {inventoryAllowCampaignInfoList: params})
  .then((response) => {
    const { data, statusCode } = response;
    if(statusCode === 200){
      returnVal = data;
    }else{
      returnVal = false
    }
  }).catch((e) => returnVal = false)
  return returnVal;
}

const WEIGHT_SCHEDULE_URL = '/adver/campaign/weight/schedules';

export async function selectAllowCampaignWeightSchedules(inventoryId) {
  let returnVal = [];
  await AdminAxios('GET', `${WEIGHT_SCHEDULE_URL}?inventoryId=${encodeURIComponent(inventoryId)}`, null)
  .then(response => {
    const {data, statusCode} = response;
    if(statusCode === 200) returnVal = data?.content || data || [];
  }).catch(() => { returnVal = false; });
  return returnVal;
}

export async function createAllowCampaignWeightSchedule(params) {
  let returnVal = false;
  await AdminAxios('POST', WEIGHT_SCHEDULE_URL, params)
  .then(response => {
    if([200, 201].includes(response.statusCode)) returnVal = response.data || true;
  }).catch(() => { returnVal = false; });
  return returnVal;
}

export async function cancelAllowCampaignWeightSchedule(scheduleId) {
  let returnVal = false;
  await AdminAxios('PUT', `${WEIGHT_SCHEDULE_URL}/${scheduleId}/cancel`, null)
  .then(response => {
    if(response.statusCode === 200) returnVal = response.data || true;
  }).catch(() => { returnVal = false; });
  return returnVal;
}
/* 선택 매체(상세) 통계 리스트 조회 */
export async function selectStaticsMediaDetail(userId, params) {
  //post
  let returnVal = null;
  if(isInit){
    return {rows: [
        {historyDate: 20250805, revenueAmount : 10, requestCount: 10, responseCount: 10, exposureCount: 10, validClickCount: 10, costAmount: 10}
      ], totalCount: 1}
  }
  await AdminAxios('POST', `/media/statistics/${userId}/media`, params)
    .then((response) => {
      const { data, statusCode } = response;
      if(statusCode === 200){
        returnVal = data;
      }else{
        returnVal = {totalElements: 0 ,content:[]}
      }
    }).catch((e) => returnVal = false)
  return returnVal;
}
